"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserModel = void 0;
var class_validator_1 = require("class-validator");
var Constants_1 = require("../Constants");
var UserModel = /** @class */ (function () {
    function UserModel() {
    }
    __decorate([
        class_validator_1.IsNumber(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Number)
    ], UserModel.prototype, "id", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], UserModel.prototype, "passwordHash", void 0);
    __decorate([
        class_validator_1.IsIn(Object.values(Constants_1.Roles)),
        __metadata("design:type", String)
    ], UserModel.prototype, "role", void 0);
    __decorate([
        class_validator_1.IsNotEmpty(),
        class_validator_1.IsEmail(),
        __metadata("design:type", String)
    ], UserModel.prototype, "email", void 0);
    return UserModel;
}());
exports.UserModel = UserModel;
//# sourceMappingURL=UserModel.js.map